import { PrivacyPolicy } from 'pages';
import React from 'react';
import { Route } from 'react-router-dom';
import { ProtectedRoutePropsType } from './types';

export const ProtectedRoutePrivacyPolicy: React.FunctionComponent<ProtectedRoutePropsType> =
  ({ path }) => {
    return (
      <Route path={path}>
        <PrivacyPolicy />
      </Route>
    );
  };
